import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the square day report view.
 * @extends JetView
 */
export default class squareDayReportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const data = [
            // Sample data for the report
            {
                Product: 'Inbet',
                Date: '2019-05-28 23:59:59',
                BetShop: 'CONCEPERU',
                EntryValue: '5478',
                OutputValue: '5978',
            },
            {
                Product: 'ragmatic',
                Date: '2019-05-29 23:59:59',
                BetShop: 'pventaperu22',
                EntryValue: '7895',
                OutputValue: '7850',
            },
            {
                Product: 'producto 3',
                Date: '2019-05-30 23:59:59',
                BetShop: 'pventaperu22',
                EntryValue: '15458',
                OutputValue: '897',
            },
        ];
        // Extending the summTreeColumn filter for custom summation
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        // Iterate through data
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from existing summColumn filter
        );
        return {
            view: 'treetable', // Define the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'SquareDay', // Unique identifier for the view
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 490 : 0, // Conditional height based on screen width
            bready: function () {
                // Function to open all rows
                this.openAll();
            },
            columns: [
                // Column definitions for the treetable
                {
                    id: 'Product',
                    header: _('Producto'), // Localized header
                    width: 350,
                    template: function (obj, common) {
                        // Template for displaying product
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouping logic
                        return obj.Product; // Return product name
                    },
                },
                {
                    id: 'EntryValue',
                    header: _('Valor Entradas'), // Localized header
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for the column
                    width: 135,
                },
                {
                    id: 'OutputValue',
                    header: _('Valor Salidas'), // Localized header
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for the column
                    width: 135,
                },
            ],
            autowidth: false, // Disable automatic width adjustment
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID for pagination
            data: data, // Initial data for the table
            url: devConfig.geturlApi() + 'Accounting/GetSquareDayReport', // API endpoint for data fetching
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        grid.attachEvent('onAfterLoad', function () {
            // Event after data load
            $$('SquareDay').data.group({
                // Group data by Date
                by: 'Date',
                map: {
                    Date: ['Date'],
                    BetShop: ['BetShop'],
                    EntryValue: ['EntryValue', 'sum'],
                    OutputValue: ['OutputValue', 'sum'],
                },
            });
            $$('SquareDay').data.group({
                // Group data by BetShop
                by: 'BetShop',
                map: {
                    EntryValue: ['EntryValue', 'sum'],
                    OutputValue: ['OutputValue', 'sum'],
                },
            });
        });
        this.on(this.app, 'squareDay:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Append dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
    }
}

// FILE DOCUMENTED
